/* tslint:disable */
/* eslint-disable */
/* @relayHash c2cf66a46ebd339df8cbddd2e68e6c7b */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type EnableExternalModerationPhaseInput = {
    clientMutationId: string;
    id: string;
};
export type EnableExternalModerationPhaseMutationVariables = {
    input: EnableExternalModerationPhaseInput;
};
export type EnableExternalModerationPhaseMutationResponse = {
    readonly enableExternalModerationPhase: {
        readonly phase: {
            readonly " $fragmentRefs": FragmentRefs<"ConfigureExternalModerationPhaseContainer_phase">;
        };
    };
};
export type EnableExternalModerationPhaseMutation = {
    readonly response: EnableExternalModerationPhaseMutationResponse;
    readonly variables: EnableExternalModerationPhaseMutationVariables;
};



/*
mutation EnableExternalModerationPhaseMutation(
  $input: EnableExternalModerationPhaseInput!
) {
  enableExternalModerationPhase(input: $input) {
    phase {
      ...ConfigureExternalModerationPhaseContainer_phase
      id
    }
  }
}

fragment ConfigureExternalModerationPhaseContainer_phase on ExternalModerationPhase {
  ...ExternalModerationPhaseDetails_phase
  ...ExternalModerationPhaseDangerZone_phase
  ...ExternalModerationPhaseStatus_phase
}

fragment ConfigureExternalModerationPhaseForm_phase on ExternalModerationPhase {
  id
  name
  url
  timeout
  format
}

fragment ExternalModerationPhaseDangerZone_phase on ExternalModerationPhase {
  id
  enabled
}

fragment ExternalModerationPhaseDetails_phase on ExternalModerationPhase {
  ...ConfigureExternalModerationPhaseForm_phase
}

fragment ExternalModerationPhaseStatus_phase on ExternalModerationPhase {
  id
  enabled
  signingSecret {
    secret
    createdAt
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EnableExternalModerationPhaseMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "EnableExternalModerationPhasePayload",
                    "kind": "LinkedField",
                    "name": "enableExternalModerationPhase",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExternalModerationPhase",
                            "kind": "LinkedField",
                            "name": "phase",
                            "plural": false,
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "ConfigureExternalModerationPhaseContainer_phase"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EnableExternalModerationPhaseMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "EnableExternalModerationPhasePayload",
                    "kind": "LinkedField",
                    "name": "enableExternalModerationPhase",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExternalModerationPhase",
                            "kind": "LinkedField",
                            "name": "phase",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "url",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "timeout",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "format",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "enabled",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SigningSecret",
                                    "kind": "LinkedField",
                                    "name": "signingSecret",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "secret",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "createdAt",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "c2cf66a46ebd339df8cbddd2e68e6c7b",
            "metadata": {},
            "name": "EnableExternalModerationPhaseMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'e9bef0c4d8677604513a002e9668dece';
export default node;
